module.exports = __webpack_public_path__ + "static/media/icon-todo-followup.2aa1b63a.svg";